import { Box, Paper, Stack, Typography } from '@mui/material';
import React from 'react';

const TopSelectBar = ({ selectedModuleType, setSelectedModuleType, moduleTypes, smDown }) => {
  return (
    <Box>
      <Paper
        elevation={2}
        sx={{
          p: '6px',
          borderRadius: '14px',
          backgroundColor: '#f3f4f6',
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          {moduleTypes.map((item) => {
            const isActive = selectedModuleType === item.id;

            return (
              <Box
                key={item.id}
                onClick={() => setSelectedModuleType(item.id)}
                sx={{
                  cursor: 'pointer',
                  flex: 1,
                  textAlign: 'center',
                  padding: smDown ? '6px 10px' : '10px 16px',
                  borderRadius: '10px',
                  transition: 'all 0.3s ease',
                  background: isActive ? 'linear-gradient(90deg, #2563eb, #7c3aed)' : '#e5e7eb',
                  color: isActive ? '#fff' : '#374151',
                  fontWeight: isActive ? 600 : 500,
                  boxShadow: isActive ? '0px 2px 8px rgba(0,0,0,0.15)' : 'none',

                  // '&:hover': {
                  //   background: isActive ? 'linear-gradient(90deg, #2563eb, #7c3aed)' : '#7f95cf52',
                  // },
                  '&:hover': {
                    background: isActive
                      ? 'linear-gradient(90deg, #2563eb, #7c3aed)'
                      : '#6346ed29',
                  },
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                <Typography variant="body2">{smDown ? item.shortName : item.name}</Typography>
              </Box>
            );
          })}
        </Stack>
      </Paper>
    </Box>
  );
};

export default TopSelectBar;
